const ONE_TRUST_TARGETING_GROUP_ID = "C0004";
export {
  ONE_TRUST_TARGETING_GROUP_ID
};
